tarteaucitron.services.keepeek = {
  "key": "keepeek",
  "type": "video",
  "name": "Keepeek",
  "uri": "https://www.keepeek.com/en/legal/privacy-policy",
  "needConsent": true,
  "cookies": ['_ga', '_gcl_au', '_gid', 'didomi_token', 'euconsent-v2', 'prism_'],
  "js": function () {
    "use strict";
    tarteaucitron.fallback(['keepeek_player'], function (x) {
      var frame_title = tarteaucitron.fixSelfXSS(x.getAttribute("title")),
        width = x.getAttribute("width"),
        height = x.getAttribute("height"),
        allowfullscreen = x.getAttribute("allowfullscreen"),
        url = x.getAttribute("data-url");

      return '<iframe title="' + frame_title + '" src="' + url + '" width="' + width + '" height="' + height + '" allow="autoplay" frameborder="0" allowfullscreen="allowfullscreen"></iframe>';
    });
  },
  "fallback": function () {
    "use strict";
    var id = 'keepeek';
    tarteaucitron.fallback(['keepeek_player'], function (elem) {
      elem.style.width = elem.getAttribute('width') + 'px';
      elem.style.height = elem.getAttribute('height') + 'px';
      return tarteaucitron.engage(id);
    });
  }
};

tarteaucitron.services.countly = {
  "key": "countly",
  "type": "analytic",
  "name": "Countly",
  "uri": drupalSettings.countly.privacy,
  "needConsent": true,
  "cookies": ["cly_id", "cly_session"], // Liste des cookies utilisés par Countly
  "js": function () {
    "use strict";
    tarteaucitron.addScript("https://cdn.jsdelivr.net/npm/countly-sdk-web@25.4.5/lib/countly.min.js", "", function () {
      console.log("Countly server script loaded [OK]");

      // Init Countly & Events definition.
      if (typeof window.Countly.init === "function") {
        console.log("Countly initialization [OK]");
        window.Countly.app_key = drupalSettings.countly.appKey;
        window.Countly.url = drupalSettings.countly.url;
        window.Countly.debug = true;
        window.Countly.init();
        window.Countly.q.push(["track_sessions"]);
        window.Countly.q.push(["track_pageview"]);
        console.log(window.Countly);
      }
      else {
        console.log("Countly init not found.");
      }
    });
  },
  "fallback": function () {
    "use strict";
    console.log("Countly désactivé, car le consentement n'a pas été donné.");
  }
};
